import { ButtonTertiary } from "@nova/component-btn"
import { useMemo, useState } from "react"
import * as Icons from "@nova/component-icons"
import { SidePanelPluginActionsNavigator } from "panels/content/side-panel/plugin-actions/SidePanelPluginActionsNavigator"
import { SidePanelPluginActionsRenamer } from "panels/content/side-panel/plugin-actions/SidePanelPluginActionsRenamer"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { createInfraredFlight } from "features/pubsub/entityActions/flights/infrared"
import { selectUserID } from "user/profile/selectors"
import { selectInfraredFlights } from "features/entity-caching/flights/selectors"
import { AddOns, SampleDataFlightKey } from "@nova/constants"
import { useAddOnRestricted } from "features/data-management/workspace/subscriptions/hooks/useAddOnRestricted"
import { setActiveFeatureId, setActiveLayerId } from "panels/content/side-panel/slice.new"

export const HotspotPluginActionBody = () => {
    const dispatch = useAppDispatch()
    const userId = useAppSelector(selectUserID)
    const flights = useAppSelector(selectInfraredFlights)
    const defaultname = `Hotspots ${Object.values(flights).length + 1}`
    const { isRestricted } = useAddOnRestricted(AddOns.Hotspots)

    const [nameInput, setNameInput] = useState(defaultname)

    const backButton = useMemo(() => {
        return {
            backTitle: "Cancel",
            onBack: () => {
                dispatch(setActiveFeatureId({ feature: undefined }))
                dispatch(setActiveLayerId({ id: undefined }))
            },
        }
    }, [dispatch])

    if (!userId) return null
    return (
        <SidePanelPluginActionsNavigator {...backButton} layerName={nameInput}>
            {/* Show layer rename field only while a method hasn't been selected yet. */}
            <SidePanelPluginActionsRenamer defaultName={defaultname} onRename={setNameInput} />
            <h5 className="text-gray-0 select-none">Select a Method</h5>
            <div className="flex flex-col gap-1 mt-2">
                <ButtonTertiary
                    key="auto"
                    title="Upload Images"
                    LeftIcon={Icons.UploadFolder}
                    height="2.5rem"
                    onClick={() => {
                        dispatch(
                            createInfraredFlight({
                                data: {
                                    createdBy: { userId },
                                },
                                context: {
                                    skippedProcessing: false,
                                    name: nameInput,
                                    sampleDataFlightKey: isRestricted
                                        ? SampleDataFlightKey.ir2
                                        : undefined,
                                },
                            })
                        )
                    }}
                    clickWillNavigate
                    className="mb-1"
                />
                <ButtonTertiary
                    key="upload"
                    title="Import Hotspot File"
                    LeftIcon={Icons.Upload}
                    height="2.5rem"
                    onClick={() => {
                        dispatch(
                            createInfraredFlight({
                                data: {
                                    createdBy: { userId },
                                },
                                context: {
                                    name: nameInput,
                                    skippedProcessing: true,
                                },
                            })
                        )
                    }}
                    clickWillNavigate
                />
            </div>
        </SidePanelPluginActionsNavigator>
    )
}
